<template>
  <div class="controls j_controls" @click="controlAction">
    <div class="play-icon j_play" :class="{'disnone': !controlsFlag}" style="display: none;"
      v-show="played"
      @click.stop="play">
      <img src="../assets/play-icon.png">
    </div>
    <div class="pause-icon j_pause" :class="{'disnone': !controlsFlag}"
      v-show="!played"
      @click.stop="pause">
      <img src="../assets/pause-icon.png">
    </div>
    <div class="mask1 j_mask1"></div>
    <div class="mask2 j_mask2"></div>
    <div class="mask3 j_mask3"></div>
    <div class="bottom">
      <div class="left" :class="{'opa0': !controlsFlag}">
        <div class="time j_start_time">00:00</div>
        <div class="bar-wrap j_bar">
          <div class="bar" @click="jumpTime">
            <div class="progress-bar j_progress_bar">
              <div class="bar-circle"></div>
            </div>
          </div>
        </div>
        <div class="time j_end_time">00:00</div>
      </div>
      <!-- <span class="full-screen j_full"
        v-show="!isFullScreen"
        @click="fullScreen">
        <img src="../assets/fullscreen-icon.png">
      </span>
      <span class="exit full-screen j_exit_full"
        v-show="isFullScreen"
        @click="exitFullScreen">
        <img src="../assets/fullscreen-exit-icon.png">
      </span> -->
      <span class="voice j_voice"
        v-show="!mutedData"
        @click.stop="muted">
        <img src="../assets/voice.png">
      </span>
      <span class="exit voice j_muted"
        v-show="mutedData"
        @click.stop="voice">
        <img src="../assets/muted.png">
      </span>
    </div>
  </div>
</template>

<script>
import browser from '@beastshop/browser'

const winWidth = window.innerWidth

export default {
  props: ['updateTime', 'duration', 'width', 'wrap', 'mutedD', 'controlsFlag', 'videoId', 'videoIndex', 'totalVideo', 'autoplay', 'loop'],

  data () {
    return {
      container: null,
      progress_bar: null,
      controls: null,
      startTime: null,
      endTime: null,
      played: false,
      isFullScreen: false,
      bar: null,
      c_wrap: null,
      mutedData: this.mutedD
    }
  },

  watch: {
    updateTime (time) {
      const t = time.split('-')

      this._updateTime(t[0], t[1])
    },

    duration (duration) {
      let t = this._format(duration)

      this.endTime.innerHTML = `${t.m}:${t.s}`
    },

    width () {//65 padding15*2+voice20+voicepadding15*2
      // console.log(this.width, '$$$$$$$$$width')
      this.bar.style.width = (this.width - 4 - (winWidth / 375 * 80 + this.startTime.clientWidth + this.endTime.clientWidth)) + 'px'
    },

    videoIndex (videoIndex) {
      console.log(this.videoId, this.totalVideo, this.videoIndex, '$$$$$$$$$$$$$$$$')
      if(!this.autoplay || !this.loop) {//非背景自动播放模式 swiper滑动暂停视频播放
        for(var i = 0; i<this.totalVideo; i++) {
          if(this.videoId) {
            this.pause()
            
            // const videoIndex = this.videoIndex || 1
            // this.controls.style.zIndex=videoIndex+6
        
          }
        }
      }
    }
  },

  mounted () {
    this.c_wrap = document.querySelector(`.${this.wrap}`)
    this.container = this.c_wrap.querySelector('.controls')
    this.progress_bar = this.container.querySelector('.j_progress_bar')
    this.controls = this.container.querySelector('.j_controls')
    this.playBtn = this.container.querySelector('.j_play')
    this.pauseBtn = this.container.querySelector('.j_pause')
    this.full_btn = this.container.querySelector('.j_full')
    this.exitFullBtn = this.container.querySelector('.j_exit_full')
    this.voiceBtn = this.container.querySelector('.j_voice')
    this.mutedBtn = this.container.querySelector('.j_muted')
    this.startTime = this.container.querySelector('.j_start_time')
    this.endTime = this.container.querySelector('.j_end_time')
    this.bar = this.container.querySelector('.j_bar')
  },

  methods: {
    controlAction () {
      this.$emit('control-action')
    },

    play () {
      this.played = false
      this.$emit('play')
    },

    pause () {
      this.played = true
      this.$emit('pause')
    },

    jumpTime (e) {
      const bar = e.currentTarget
      const pos = e.layerX
      const total = bar.clientWidth
      const time = this.computeTime(pos, total)

      this.$emit('jump', time)
      this._updateTime(time, this.duration)
    },

    fullScreen () {
      this._fullScreen()
      this.$emit('full')
    },

    exitFullScreen () {
      this._exitFullScreen()
      this.$emit('exitfull')
    },

    _fullScreen() {
      if (browser.ios) {
        this.isFullScreen = true
      }
    },

    _exitFullScreen() {
      if (browser.ios) {
        this.isFullScreen = false
      }
    },

    muted () {
      this.mutedData = true
      this.$emit('mutedA')
    },

    voice () {
      this.mutedData = false
      this.$emit('voice')
    },

    computeTime (cur, total) {
      return (cur / total).toFixed(2) * this.duration
    },

    _updateTime (time, duration) {
      let t = this._format(time)
      this.startTime.innerHTML = `${t.m}:${t.s}`

      if (duration) {
        this.progress_bar.style.width = time / duration * 100 + '%'
      }
    },


    _format (time) {
      let t = Math.floor(time)
      let m = Math.floor(t / 60)
      let s = t - m * 60
      return {
        m: m < 10 ? `0${m}` : m,
        s: s < 10 ? `0${s}` : s
      }
    }
  }
}
</script>

<style lang="stylus">
</style>



// WEBPACK FOOTER //
// controller.vue?29721630